var map = {
	"./AcneIcon.tsx": [
		37797,
		7797
	],
	"./AllergyIcon.tsx": [
		88252,
		8252
	],
	"./AmbulanceIcon.tsx": [
		75930,
		5930
	],
	"./AppIcon.tsx": [
		53909,
		3909
	],
	"./AppInvertedIcon.tsx": [
		50686,
		686
	],
	"./Baby2Icon.tsx": [
		93070,
		3070
	],
	"./BabyIcon.tsx": [
		71550,
		1550
	],
	"./BackpainIcon.tsx": [
		16815,
		6815
	],
	"./BandageIcon.tsx": [
		65894,
		5894
	],
	"./BandaidIcon.tsx": [
		65433,
		5433
	],
	"./BirthcontrolIcon.tsx": [
		85872,
		5872
	],
	"./BiteIcon.tsx": [
		3188,
		3188
	],
	"./BloodIcon.tsx": [
		46756,
		6756
	],
	"./BurnoutIcon.tsx": [
		86557,
		6557
	],
	"./BusIcon.tsx": [
		31054,
		1054
	],
	"./CalendarIcon.tsx": [
		38580,
		8580
	],
	"./CalmIcon.tsx": [
		89343,
		9343
	],
	"./CancerIcon.tsx": [
		76626,
		6626
	],
	"./CapsuleIcon.tsx": [
		61293,
		1293
	],
	"./CategoryIcon.tsx": [
		19606,
		9606
	],
	"./CertificateIcon.tsx": [
		82761,
		2761
	],
	"./ChlamydiaIcon.tsx": [
		85620,
		5620
	],
	"./CleanHandIcon.tsx": [
		28384,
		8384
	],
	"./ClinicIcon.tsx": [
		40274,
		274
	],
	"./ColdIcon.tsx": [
		50844,
		844
	],
	"./CoughIcon.tsx": [
		65686,
		5686
	],
	"./CreamIcon.tsx": [
		79402,
		9402
	],
	"./DietIcon.tsx": [
		66156,
		6156
	],
	"./DigestionIcon.tsx": [
		50490,
		490
	],
	"./DizzyIcon.tsx": [
		34582,
		4582
	],
	"./DoctorIcon.tsx": [
		27075,
		7075
	],
	"./DropsIcon.tsx": [
		62002,
		2002
	],
	"./EarIcon.tsx": [
		22096,
		2096
	],
	"./EffervescentIcon.tsx": [
		8086,
		8086
	],
	"./EpipenIcon.tsx": [
		24935,
		4935
	],
	"./FaceIcon.tsx": [
		30141,
		141
	],
	"./FacemaskIcon.tsx": [
		88341,
		8341
	],
	"./FeetIcon.tsx": [
		80258,
		258
	],
	"./FeverIcon.tsx": [
		13614,
		3614
	],
	"./FingersIcon.tsx": [
		42946,
		2946
	],
	"./FirstaidIcon.tsx": [
		94818,
		4818
	],
	"./GenitalIcon.tsx": [
		67578,
		7578
	],
	"./GynecologyIcon.tsx": [
		39460,
		9460
	],
	"./HandIcon.tsx": [
		97721,
		7721
	],
	"./HandicapIcon.tsx": [
		44918,
		4918
	],
	"./HappyIcon.tsx": [
		70702,
		702
	],
	"./HeadacheIcon.tsx": [
		93649,
		3649
	],
	"./HeartIcon.tsx": [
		58088,
		8088
	],
	"./HerpesIcon.tsx": [
		77833,
		7833
	],
	"./HomeIcon.tsx": [
		49679,
		9679
	],
	"./HormonesIcon.tsx": [
		69921,
		9921
	],
	"./InfusionIcon.tsx": [
		12355,
		2355
	],
	"./InhalerIcon.tsx": [
		69,
		69
	],
	"./InsectIcon.tsx": [
		28014,
		8014
	],
	"./IntimateIcon.tsx": [
		72041,
		2041
	],
	"./KidneysIcon.tsx": [
		13303,
		3303
	],
	"./LightEmergency.tsx": [
		33370,
		3370
	],
	"./LiverIcon.tsx": [
		26588,
		6588
	],
	"./LungsIcon.tsx": [
		19911,
		9911
	],
	"./LymphIcon.tsx": [
		16958,
		6958
	],
	"./MaleGenitalsIcon.tsx": [
		21864,
		1864
	],
	"./MapIcon.tsx": [
		17654,
		7654
	],
	"./MenopauseIcon.tsx": [
		24583,
		4583
	],
	"./MentalHealthIcon.tsx": [
		94215,
		4215
	],
	"./MetabolismIcon.tsx": [
		50857,
		857
	],
	"./MigraineIcon.tsx": [
		15442,
		5442
	],
	"./MildEmergencyIcon.tsx": [
		92773,
		2773
	],
	"./MouthIcon.tsx": [
		55797,
		5797
	],
	"./MuscleIcon.tsx": [
		16435,
		6435
	],
	"./NasalSprayIcon.tsx": [
		23102,
		3102
	],
	"./NeurologyIcon.tsx": [
		42386,
		2386
	],
	"./PainIcon.tsx": [
		69466,
		9466
	],
	"./PancreasIcon.tsx": [
		39278,
		6897
	],
	"./PelvisIcon.tsx": [
		72681,
		2681
	],
	"./PenIcon.tsx": [
		98001,
		8001
	],
	"./PeriodDelayIcon.tsx": [
		60680,
		680
	],
	"./PeriodIcon.tsx": [
		60813,
		813
	],
	"./PhysioTherapistIcon.tsx": [
		74202,
		4202
	],
	"./PhysioTherapy2Icon.tsx": [
		72769,
		2769
	],
	"./PhysioTherapyIcon.tsx": [
		88387,
		8387
	],
	"./PillBottleIcon.tsx": [
		42891,
		2891
	],
	"./PregnancyIcon.tsx": [
		13997,
		3997
	],
	"./PrescriptionIcon.tsx": [
		41610,
		1610
	],
	"./PuzzleIcon.tsx": [
		49474,
		9474
	],
	"./SadIcon.tsx": [
		49164,
		9164
	],
	"./SerringeIcon.tsx": [
		85339,
		5339
	],
	"./SexualHealthIcon.tsx": [
		58106,
		8106
	],
	"./ShouldersIcon.tsx": [
		68235,
		8235
	],
	"./SkeletonIcon.tsx": [
		94935,
		7316
	],
	"./SkinIcon.tsx": [
		54249,
		4249
	],
	"./SleepIcon.tsx": [
		1217,
		1217
	],
	"./SleepyEyeIcon.tsx": [
		525,
		525
	],
	"./SpraybottleIcon.tsx": [
		67739,
		7739
	],
	"./StomachIcon.tsx": [
		53263,
		3263
	],
	"./StomachVariantIcon.tsx": [
		71820,
		1820
	],
	"./StressIcon.tsx": [
		58818,
		8818
	],
	"./SuppositoryIcon.tsx": [
		23947,
		3947
	],
	"./SweatIcon.tsx": [
		32520,
		2520
	],
	"./TabletsIcon.tsx": [
		11671,
		1671
	],
	"./TasteIcon.tsx": [
		40125,
		125
	],
	"./TestIcon.tsx": [
		28298,
		8298
	],
	"./TestResultIcon.tsx": [
		62701,
		2701
	],
	"./TesttubeIcon.tsx": [
		38036,
		8036
	],
	"./ThroatIcon.tsx": [
		24308,
		4308
	],
	"./TongueIcon.tsx": [
		16394,
		6394
	],
	"./TummyAcheIcon.tsx": [
		88865,
		8865
	],
	"./UrinalInfectionIcon.tsx": [
		62222,
		2222
	],
	"./UrineIcon.tsx": [
		66629,
		6629
	],
	"./VaccinationIcon.tsx": [
		97059,
		7059
	],
	"./VisionIcon.tsx": [
		24486,
		4486
	],
	"./WaitingRoomIcon.tsx": [
		87592,
		7592
	],
	"./WaterIcon.tsx": [
		60713,
		713
	],
	"./WormIcon.tsx": [
		93979,
		3979
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64612;
module.exports = webpackAsyncContext;